<template>
  <div id="Index">
    <Head />
    <!-- <Login @isLoginOpen="isLoginOpen" v-if="isLogin" /> -->
    <RightNav />
    <div class="index">
      <div class="mainB">
        <div class="img">
          <el-carousel height="5.5rem">
            <el-carousel-item v-for="item in Img" :key="item.id">
              <img :src="item.imgurl" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="notice">
          <div class="nTop">
            <div>
              <!-- <label :class="{active : nTop == 1}">
                <input
                  type="radio"
                  @click="nImg = notice[1][0].img; nMouseI = 0"
                  name="noticeClass"
                  value="1"
                  v-model="nTop"
                />
                <img
                  :src="nTop == 1 ? require('../../assets/Index/zhinanda.png') : require('../../assets/Index/zhinan.png')"
                  :class="nTop==1?'bigIcion':''"
                  class="i1"
                />申报指南
              </label>-->
              <label :class="{ active: nTop == 0 }" style="margin-left:0">
                <input type="radio" @click="nav(nTop)" name="noticeClass" value="0" v-model="nTop" />
                <img :src="
                    nTop == 0
                      ? require('../../assets/Index/redianda.png')
                      : require('../../assets/Index/redian.png')
                  " :class="nTop == 0 ? 'bigIcion' : ''" />热点动态
              </label>
              <label :class="{ active: nTop == 1 }">
                <input type="radio" @click="nav(nTop)" name="noticeClass" value="1" v-model="nTop" />
                <img :src="
                    nTop == 1
                      ? require('../../assets/Index/gonggaoda.png')
                      : require('../../assets/Index/gonggao1.png')
                  " :class="nTop == 1 ? 'bigIcion' : ''" />通知公告
              </label>
            </div>
            <div class="more" @click="strip(nTop)">More>></div>
          </div>
          <div class="nMain">
            <ul v-show="nTop == 0">
              <li @mouseover="nMouse(index)" v-for="(item, index) in notice[0]" :key="index" v-show="notice[0]" @click="addClass(index, 'aa', notice[0][index].ID)">
                <router-link :to="`/Hotspot/HotDetails?newsID=${item.ID}`" target="_blank" class="aa">
                  <div :title="item.Title">
                    <span></span>
                    {{ item.Title | sLen }}
                  </div>
                  <div>{{ item.Date }}</div>
                </router-link>
              </li>
            </ul>
            <ul v-show="nTop == 1">
              <li @mouseover="nMouse(index)" :class="{ nActive: nMouseI == index }" v-for="(item, index) in notice[1]" :key="index" v-show="notice[1]" @click="addClass(index, 'bb', notice[1][index].ID)">
                <router-link :to="`/Hotspot/HotDetails?newsID=${item.ID}`" target="_blank" class="bb">
                  <div :title="item.Title">
                    <span></span>
                    {{ item.Title | sLen }}
                  </div>
                  <div>{{ item.Date }}</div>
                </router-link>
              </li>
            </ul>
            <!-- <ul v-show="nTop == 2">
              <li
                v-show="notice[2]"
                @mouseover="nMouse(index)"
                :class="{nActive : nMouseI == index}"
                v-for="(item,index) in notice[2]"
                :key="index"
                @click="addClass(index,'cc',notice[2][index].ID)"
              >
                <router-link
                  :to="`/Hotspot/HotDetails?newsID=${item.ID}`"
                  target="_blank"
                  class="cc"
                >
                  <div :title="item.Title">
                    <span></span>
                    {{item.Title|sLen }}
                  </div>
                  <div>{{item.Date}}</div>
                </router-link>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
      <div class="mainC" @click="$router.push('/Classroom')">
        <img :src="imgCenter" class="ImgA" />
        <!-- <img src="../../assets/Index/12.png" class="ImgB" /> -->
      </div>
      <div class="mainD">
        <div>
          <div class="bor">
            <span></span>
          </div>
          <div class="bText" id="biaogan">
            <img src="../../assets/Index/qiye.png" />标杆企业
          </div>
          <div class="bMain">
            <ul>
              <!-- <li
                v-for="(item,index) in funModule[0]"
                :class="{active : item.active}"
                :key="index"
                @mouseout="mouseA(index,0)"
                @mouseover="mouseB(index,0)"
                @click="translation(index,0)"
              >
                <img :src="item.active? item.imgs : item.img" />
                {{item.name}}
              </li>-->
              <li v-for="(item, index) in funModule[0]" :key="index" @click="translation(index, 0)">
                <img :src="item.img" /> {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div class="bor">
            <span></span>
          </div>
          <div class="bText">
            <img src="../../assets/Index/zhuanhuan.png" />项目转化
          </div>
          <div class="bMain">
            <ul>
              <!-- <li
                v-for="(item,index) in funModule[1]"
                :class="{active : item.active}"
                :key="index"
                @mouseout="mouseA(index,1)"
                @mouseover="mouseB(index,1)"
                @click="translation(index,1)"
              >
                <img :src="item.active? item.imgs : item.img" />
                {{item.name}}
              </li>-->
              <li v-for="(item, index) in funModule[1]" :key="index" @mouseout="mouseA(index, 1)" @mouseover="mouseB(index, 1)" @click="translation(index, 1)">
                <img :src="item.img" /> {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mainF">
        <div>友情链接</div>
        <div>
          <ul>
            <li v-for="(item, index) in Connect" :key="index">
              <a target="_blank" :href="item.url">
                <img :src="item.cover" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Advertising v-if="showView" ref="ad" :json="json" @closeView="closeView" />
      <Announcement v-if="dialogShow" ref="an" :json="json" @closeViewAn="closeViewAn" />
      <!-- <Advertising></Advertising> -->
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
// import Login from "../../components/Login";
import RightNav from "../../components/RightNav";
import Advertising from "../../components/Advertising";
import Announcement from "../../components/Announcement";
export default {
  name: "Index",
  data() {
    return {
      dialogShow: false, // 弹窗是否显示：true显示、false关闭
      json: {
        src: require("../../assets/Index/guanggao.jpg"),
        url: "http://39.100.116.249/#/Hotspot/HotDetails?newsID=427",
        left: 100,
        top: 400,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: null,
        zIndex: null,
        width: null,
        height: null,
        noHoverPause: null, //鼠标经过时不停止，为true时不停止
        cursor: null,
      },
      showView: false,
      aa: "",
      nTop: 0,
      nMouseI: 0,
      nImg: "http://res.lgdsunday.club/blogs.jpg",
      isLogin: false,
      // 首页左侧
      Img: [],
      imgCenter: "",
      Index: "",
      //新闻 [[],[],[]] 每项最多7条
      notice: [],

      funModule: [
        [
          {
            name: "企业名录",
            // img: require("../../assets/Index/mulu.png"),
            img: require("../../assets/Index/企业名录).png"),
            imgs: require("../../assets/Index/s2.png"),
            active: false,
            to: "/entTable",
          },
          {
            name: "企业简介",
            // img: require("../../assets/Index/xq.png"),
            img: require("../../assets/Index/企业简介.png"),
            imgs: require("../../assets/Index/s4.png"),
            active: false,
            // to: "/Introductory"
            to: "/Construction",
          },
          {
            name: "企业动态",
            // img: require("../../assets/Index/dongtai.png"),
            img: require("../../assets/Index/企业动态.png"),
            imgs: require("../../assets/Index/s6.png"),
            active: false,
            // to: "/Dynamic"
            to: "/Construction",
          },
          {
            name: "员工风采",
            // img: require("../../assets/Index/yuangong.png"),
            img: require("../../assets/Index/员工风采.png"),
            imgs: require("../../assets/Index/s8.png"),
            active: false,
            // to: "/Elegant"
            to: "/Construction",
          },
        ],
        [
          {
            name: "成果导航",
            // img: require("../../assets/Index/nav.png"),
            img: require("../../assets/Index/成果导航.png"),
            imgs: require("../../assets/Index/s10.png"),
            active: false,
            // to: "/Translation/0"
            to: "/Construction",
          },
          {
            name: "市场信息",
            // img: require("../../assets/Index/xinxi.png"),
            img: require("../../assets/Index/市场信息.png"),
            imgs: require("../../assets/Index/s12.png"),
            active: false,
            // to: "/Translation/1"
            to: "/Construction",
          },
          {
            name: "成功案例",
            // img: require("../../assets/Index/anli.png"),
            img: require("../../assets/Index/成功案例.png"),
            imgs: require("../../assets/Index/s14.png"),
            active: false,
            to: "/Construction",
          },
          {
            name: "保障支持",
            // img: require("../../assets/Index/anquan.png"),
            img: require("../../assets/Index/保障支持.png"),
            imgs: require("../../assets/Index/s16.png"),
            active: false,
            to: "/Construction",
          },
        ],
      ],
      Connect: [],
      flag: false,
    };
  },

  created() {
    this.getBanner();
    this.getConnect();
    this.getDialogShow();
    console.log(this.showView, this.dialogShow);
  },
  mounted() {
    this.news();
    // this.isMobile();
  },
  beforeDestroy() {
    if (this.$refs.ad) {
      this.closeView();
    }
    if (this.$refs.an) {
      this.closeViewAn();
    }
  },
  methods: {
    // 弹窗是否显示
    getDialogShow() {
      this.$axios.post("log/visitnums_show").then((res) => {
        if (res.data.code == 10000) {
          this.dialogShow = res.data.data.showstatus == 0;
        }
      });
    },

    //1-首页顶部 2-首页左侧 3-首页中部 4-热点动态 5-创新课堂 6-创新课堂图1 7-创新课堂图2
    getBanner() {
      let that = this;
      this.$axios
        .post(
          "banner/info",
          that.$qs.stringify({
            banner_id: "2",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.Img = res.data.data.list;
          }
        });
      this.$axios
        .post(
          "banner/info",
          that.$qs.stringify({
            banner_id: "3",
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.imgCenter = res.data.data.list[0].imgurl;
          }
        });
    },
    getConnect() {
      this.$axios
        .post("cooperate/friend?token=" + sessionStorage.getItem("token"))
        .then((res) => {
          if (res.data.code == 10000) {
            this.Connect = res.data.data.list;
          }
        });
    },
    closeView() {
      console.log(this.showView);
      this.showView = false;
    },
    closeViewAn() {
      this.dialogShow = false;
    },
    nav(i) {
      this.nMouse = i;
    },
    addClass(i, class1, id) {
      document.getElementsByClassName(class1)[i].classList.add("m");
      this.$axios.post("information/clicknums?ID=" + id);
    },
    strip(i) {
      // console.log(i)
      if (i == 0) {
        this.$router.push("/Hotspot");
      } else if (i == 1) {
        this.$router.push("/Notice");
        //console.log(i);
      }
    },
    async news() {
      let _this = this;
      await _this.$axios
        .post("information/index?Type=10&provinceid=37&num=7&status=0")
        .then((res) => {
          if (res.data.code == 10000) {
            this.notice.push(res.data.data.list);
          }
        });
      await _this.$axios
        .post("information/index?Type=4&status=0&num=7")
        .then((res) => {
          if (res.data.code == 10000) {
            this.notice.push(res.data.data.list);
          }
        });
    },
    nMouse(i) {
      console.log(i);
      if (this.nMouseI != i) {
        this.nMouseI = i;
        this.nImg = this.notice[this.nTop][i].img;
      }
    },
    details(navI, index) {
      // let url=  this.notice[navI][index].Details
      //  console.log(url);

      this.Index = index;
      let routeUrl = this.$router.resolve({
        path: "/Hotspot/HotDetails",
        // query: { url:url }
        query: { id: navI, news: index },
      });
      window.open(routeUrl.href, "_blank");
    },
    // isLoginOpen(e) {
    //   console.log(2);
    //   this.isLogin = e;
    // },
    mouseA(i, e) {
      this.funModule[e][i].active = false;
    },
    mouseB(i, e) {
      this.funModule[e][i].active = true;
    },
    translation(i, s) {
      if (s == 0) {
        if (this.funModule[0][i].to != "")
          this.$router.push(this.funModule[0][i].to);
      } else {
        if (this.funModule[1][i].to != "")
          this.$router.push(this.funModule[1][i].to);
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      console.log(flag, 11111);
      if (flag) this.flag = true;
    },
  },
  components: {
    Head,
    Foot,
    Advertising,
    // Login,
    RightNav,
    Announcement,
  },
  filters: {
    sLen(val) {
      if (val.length > 50) {
        val = val.slice(0, 45) + "...";
      }
      return val;
    },
  },
};
</script>
<style lang="less" scope>
#Index {
  .phone {
    position: fixed;
    left: 0%;
    top: 15%;
    z-index: 1000;
    cursor: pointer;

    img {
      // width: 50%;
      // height: 100%;
    }
  }

  .guang {
    position: fixed;

    left: 0;
    top: 14%;
    z-index: 1000;
    cursor: pointer;

    img {
      width: 50%;
      // height: 50%;
      // height: 7.8rem;
    }
  }

  .index {
    width: 100%;
    min-width: 1000px;
    padding: 0 1.35rem;
    box-sizing: border-box;
    position: relative;

    > div {
      margin-top: 0.4rem;
    }

    .mainB {
      height: 5.6rem;
      width: 100%;
      display: flex;

      .img {
        width: 5.15rem;
        height: 100%;
        margin-right: 0.3rem;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .notice {
        width: calc(100% - 5.45rem);
        height: 100%;

        // border: 0.01rem solid #ececec;
        .nTop {
          position: relative;
          display: flex;
          font-size: 0.2rem;
          border-bottom: 0.01rem solid #ececec;
          padding: 0.15rem 0;
          box-sizing: border-box;
          justify-content: space-between;
          color: #c7c7c7;

          .more {
            width: 1.3rem;
            height: 0.4rem;
            border: 0.01rem solid #c7c7c7;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0.05rem;
            // margin-right: 0.4rem;
            cursor: pointer;
            position: absolute;
            right: 0;
            top: 5.5rem;
          }

          .more:hover {
            color: #fff;
            background: #3f6bc2;
          }

          div {
            display: flex;
            align-items: center;

            label {
              cursor: pointer;
              display: flex;
              align-items: center;
              margin-left: 0.4rem;

              img {
                width: 0.4rem;
                height: 0.4rem;
                box-sizing: border-box;
                padding: 0.1rem;
                // border-radius: 50%;
                // border: 0.01rem solid #c7c7c7;
                margin: 0 0.1rem;
              }

              .i1 {
                padding: 0.06rem;
              }

              .bigIcion {
                width: 0.5rem;
                height: 0.5rem;
              }

              &.active {
                color: #3f6bc2;
              }

              > input {
                width: 0;
                opacity: 0;
              }
            }
          }
        }

        .nMain {
          padding: 0 0.2rem;

          ul {
            width: 100%;

            li {
              cursor: pointer;
              width: 100%;

              font-size: 0.19rem;
              // color: #929292;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 0.01rem solid #c7c7c7;

              a:-webkit-any-link {
                color: #000;
              }

              a.m:visited {
                color: orange;
              }

              a:hover {
                color: #3f6bc2;
              }

              a {
                z-index: 10;
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: space-between;
                padding: 0.19rem 0;

                > div {
                  display: flex;
                  align-items: center;

                  span {
                    display: inline-block;
                    height: 0.1rem;
                    width: 0.1rem;
                    border-radius: 50%;
                    background: #3f6bc2;
                    margin-right: 0.1rem;
                  }
                }
              }

              > div:last-child {
                font-size: 0.15rem;
              }
            }
          }
        }
      }
    }

    .mainC {
      width: 100%;
      position: relative;
      margin-top: 0.8rem;
      cursor: pointer;

      .ImgA {
        width: 100%;
        position: relative;
        display: block;
      }

      .ImgB {
        width: 7.69rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .mainD {
      width: 100%;
      display: flex;
      // align-items: center;
      justify-content: space-between;

      > div {
        width: calc(50% - 0.5rem);
        height: 100%;
        border: 0.01rem solid #ececec;
        position: relative;

        .bor {
          width: 100%;
          height: 0.04rem;
          background: #147de5;
          position: relative;
          top: 0;
          left: 0;

          > span {
            position: absolute;
            display: block;
            top: 0.02rem;
            left: 50%;
            transform: translateX(-50%);
            border: 0.1rem solid #147de5;
            border-left-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        }

        .bText {
          font-size: 0.25rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 0.25rem;
          color: #2d2d2d;

          > img {
            margin-right: 0.1rem;
          }
        }

        .bMain {
          ul {
            display: flex;
            font-size: 0.2rem;
            padding: 0.4rem 1rem 0.25rem;
            flex-wrap: wrap;
            justify-content: space-between;

            li {
              cursor: pointer;
              width: 2.37rem;
              margin-bottom: 0.2rem;
              height: 0.66rem;
              flex-shrink: 0;
              position: relative;
              text-align: center;
              padding-left: 0.4rem;

              // background: #f2f2f2;
              // border: 0.01rem solid #e1dee2;
              // border-radius: 0.05rem;
              background-image: url("../../assets/Index/底图.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
              color: #fff;
              line-height: 0.5rem;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 0.25rem;
                // margin-right: 0.15rem;
                position: absolute;
                left: 0.2rem;
              }

              &.active {
                background: #0c9ae5;
              }
            }
          }
        }
      }
    }

    .mainF {
      // display: flex;
      font-size: 0.2rem;
      color: #3f6bc2;
      width: 100%;

      div {
        text-align: center;
        font-size: 0.3rem;
        margin: 0.3rem 0 0.2rem 0;
      }

      > div {
        width: 100%;

        > ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          li {
            width: 20%;
            padding: 0 0.2rem;
          }
        }

        img {
          // width: 2.5rem;
          width: 100%;
          height: 100%;
          display: block;
          // margin-bottom: 0.15rem;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
